<template>
  <div
    class="relative px-4 pt-5 pb-4 mb-2 bg-white rounded-md border border-b-2 model-item border-line md:pt-6 md:pb-8 md:px-8"
  >
    <div class="flex justify-between">
      <h1 class="font-semibold md:text-xl">{{ props.model.name }}</h1>
      <button v-if="isEstimateSubmit" @click="onTrash">
        <i class="text-2xl fi fi-rs-trash"></i>
      </button>
    </div>
    <div v-if="model" class="mt-5">
      <div class="justify-between md:flex">
        <div class="md:flex">
          <div class="flex md:w-96">
            <thumbnail
              :size="''"
              :url="props.model.thumbnailUrl"
              :defaultIcon="false"
              :customCss="'mr-6 w-24 h-24 bg-layout md:w-32 md:h-32'"
              :borderWidth="1"
              :borderColor="'#c0c2c4'"
              :round="'5px'"
            >
              <template v-slot:default-icon
                ><i class="flex text-7xl fi fi-tr-cubes text-placeholder"></i
              ></template>
            </thumbnail>
            <div class="py-1">
              <div>
                <div class="text-xs text-desc md:text-md">
                  <span>크기:</span
                  ><span class="ml-1"
                    >{{ parseFloat(props.model.modelSizeX.toFixed(2)) }} x
                    {{ parseFloat(props.model.modelSizeY.toFixed(2)) }} x
                    {{ parseFloat(props.model.modelSizeZ.toFixed(2))
                    }}{{ props.model.modelUnit }}</span
                  >
                </div>
                <div class="mt-2 text-xs text-desc md:text-md md:mt-3">
                  <span>부피:</span
                  ><span class="ml-1"
                    >{{ numberToComma(props.model.modelVolume) }}㎜<sup>3</sup></span
                  >
                </div>
              </div>
              <div class="mt-3 md:mt-4">
                <button
                  class="cs-btn cs-pd-btn-xs"
                  :class="[classAnalysis]"
                  @click="onShowViewer"
                  :id="'btn_' + props.model.id + '_analysis'"
                >
                  <div class="flex items-center">
                    <i class="fi fi-rr-cubes"></i>
                    <span class="mr-1 ml-1 text-sm md:text-md">자동분석 결과: </span
                    ><span class="text-sm md:text-md">{{ totalAnalysis }}</span>
                  </div>
                </button>

                <div v-if="false" class="m-auto mt-2 cs-caption">
                  <i class="mr-1 fi fi-br-exclamation"></i>
                  <div class="text-left">
                    <p style="line-height: 1.3">
                      위 항목을 클릭하면 상세 내용을<br />확인할 수 있습니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mr-6 ml-6 border-l border-line"></div>
          <div class="mt-5 md:w-60 md:mt-0">
            <p class="text-sm text-desc">공정·재료</p>
            <div class="mt-1 mb-3 border-b border-line"></div>
            <dropdown
              :title="dropProcessTitle"
              :items="dropProcess"
              @onClick="onDropProcess"
            ></dropdown>
            <dropdown
              class="mt-3"
              :title="dropMaterialTitle"
              :items="dropMaterial"
              @onClick="onDropMaterial"
            ></dropdown>
            <div class="flex items-center mt-7 md:mt-5">
              <label
                class="mr-5 text-xs info-circle info-paint form-check-label md:text-md"
                for="pating"
                >도색</label
              >
              <input
                class="form-check-input"
                id="pating"
                type="checkbox"
                v-model="isPaint"
                @change="onChangePainting"
              />
            </div>
          </div>
          <div class="mr-6 ml-6 border-l border-line"></div>
          <div class="mt-5 mb-5 border-t border-line md:hidden"></div>
          <div class="mt-5 md:w-24 md:mt-0">
            <p class="text-sm text-desc">수량</p>
            <div class="mt-1 mb-3 border-b border-line"></div>
            <div class="flex w-full cs-form" data-height="s">
              <input
                class="text-xs md:text-md"
                type="number"
                v-model="modelCount"
                @input="onModelCount"
                @blur="onBlurModelCount"
                min="1"
                max="30"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              />
            </div>
          </div>
          <div class="mr-6 ml-6 border-l border-line"></div>
        </div>
        <div class="justify-end items-center mt-8 md:flex md:mt-0">
          <div class="text-right">
            <div class="">
              <div>
                <span class="mr-1 text-desc">단가</span>
                <span class="font-semibold text-desc">{{
                  numberToComma(props.model.modelCost)
                }}</span>
                원
              </div>
            </div>
            <div class="mt-3 mb-3 border-b border-line"></div>
            <div>
              <span class="mr-3 text-1desc">비용</span>
              <span class="text-4xl font-bold"
                >{{ numberToComma(props.model.modelTotalCost) }}원</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="props.model.analysis && !props.model.analysis.length"
        class="justify-center items-center rounded-md bounding-loader"
      >
        <div class="loader-boxs">
          <div class="scene">
            <div class="plane">
              <div class="cube cube--0">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--0"></div>
              <div class="cube cube--1">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--1"></div>
              <div class="cube cube--2">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--2"></div>
              <div class="cube cube--3">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--3"></div>
              <div class="cube cube--4">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--4"></div>
              <div class="cube cube--5">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--5"></div>
              <div class="cube cube--6">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--6"></div>
              <div class="cube cube--7">
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
                <div class="cube__side"></div>
              </div>
              <div class="shadow shadow--7"></div>
            </div>
          </div>
        </div>
        <div class="text-center bounding-loader-text">
          <p class="">업로드 및 분석 중 입니다, 잠시만 기다려주세요.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info-circle {
  position: relative;

  &::after {
    content: "?";
    display: flex;
    position: absolute;
    top: -15px;
    right: -12px;
    width: 1.1rem;
    height: 1.1rem;
    padding: 0.2rem;
    border-radius: 50%;
    background-color: var(--color-second-light);
    color: var(--color-second);
    font-size: 0.8rem;
    font-weight: 600;
    text-align: center;
    justify-content: center;
  }
}
</style>

<script setup>
import {onMounted, ref, computed, watch} from "vue";
import {storeToRefs} from "pinia";
import {CommonStore} from "../store/common-store";
import {OptionsStore} from "../store/options-store";
import {EstimateStore} from "../store/estimate-store";
import {ModelStore} from "../store/model-store";
import {binaryToArrayBuffer, reqCompletedUpload, reqStp2Stl, reqUploadModel} from "../js/upload";
import {numberToComma} from "../js/utils";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-away.css";
import Dropdown from "../components/DropDown.vue";
import Thumbnail from "../components/ThumbnailBox.vue";
import axios from "axios";
import {genStpThumbnail, genThumbnail} from "../js/three";
import {toast} from "vue3-toastify";
import {AnalysisStatus, AnalysisStatusKo, Modals} from "../js/types";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const {modalResult} = storeToRefs(CommonStore());
const optionsStore = OptionsStore();
const {processes, materials, optionCautionPaint} = storeToRefs(optionsStore);
const estimateStore = EstimateStore();
const {isEstimateSubmit} = storeToRefs(estimateStore);
const modelStore = ModelStore();

const modelCount = ref(1);
const dropProcessTitle = ref("");
const dropMaterialTitle = ref("");
const isPaint = ref(props.model.modelPaint);
const currentPercent = ref(0);

watch(isPaint, (val) => {
  modelStore.setModelPaint(props.model.id, val);
});

watch(modalResult, (newV) => {
  if (props.model.id !== newV.result.modelId) return;
  if (newV.modalName === Modals.ModelTrash) {
    modelStore.removeModel(props.model.id);
  }
});

onMounted(async () => {
  if (optionCautionPaint.value && optionCautionPaint.value.length) {
    tippy(".info-paint", {
      content: `<pre>${optionCautionPaint.value}</pre>`,
      allowHTML: true,
    });
  }
  tippy(".info-qua", {
    content: `<pre>최적화 수량은 ...</pre>`,
    allowHTML: true,
  });

  if (!props.model.isUploaded) {
    const arrayBuffer = await binaryToArrayBuffer(props.model.file);
    if (arrayBuffer) {
      await reqUploadModel(props.model, arrayBuffer, currentPercent);

      const ext = props.model.name.slice(props.model.name.lastIndexOf(".") + 1).toLowerCase();
      if (["stp", "step"].includes(ext)) {
        try {
          await reqStp2Stl(props.model);
          let key = props.model.modelKey + ".stp.stl";
          axios.post(`/models/${props.model.id}`, {key}).then((r) => {
            genStpThumbnail(props.model, r.data.result.signedUrl);
          });
        } catch (e) {
          console.error(e);
          toast.error(`${props.model.name} 업로드가 중지되었습니다.`);
          return;
        }
      } else {
        genThumbnail(props.model, props.model.file);
      }

      // if (process.env.NODE_ENV !== "production") {
      // const ext = props.model.name.slice(props.model.name.lastIndexOf(".") + 1).toLowerCase();
      // if (["stp", "step"].includes(ext)) {
      //   try {
      //     await reqStp2Stl(props.model);
      //     let key = props.model.modelKey + ".stp.stl";
      //     axios.post(`/models/${props.model.id}`, {key}).then((r) => {
      //       genStpThumbnail(props.model, r.data.result.signedUrl);
      //     });
      //   } catch (e) {
      //     console.error(e);
      //     toast.error(`${props.model.name} 업로드가 중지되었습니다.`);
      //     return;
      //   }
      // } else {
      //   genThumbnail(props.model, props.model.file);
      // }
      // } else {
      //   genThumbnail(props.model, props.model.file);
      // }
      reqCompletedUpload(props.model);
    }
  }

  for (let m = 0; m < materials.value.length; m++) {
    const mate = materials.value[m];
    if (props.model.modelProcessId === mate.processId) {
      dropMaterialTitle.value = mate.name;
      break;
    }
  }
});

const classAnalysis = computed(() => {
  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return "cs-btn-disabled";
    case AnalysisStatus.Warn:
      return "cs-btn-warn";
    case AnalysisStatus.Caution:
      return "cs-btn-caution";
    default:
      return "cs-btn-success";
  }
});
const totalAnalysis = computed(() => {
  if (AnalysisStatus.Processing === props.model.modelAnalysis) return AnalysisStatusKo.Processing;
  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    default:
      return AnalysisStatusKo.Pass;
  }
});
const dropProcess = computed(() => processes.value.map((val) => ({title: val.name, data: val})));
const dropMaterial = computed(() =>
  materials.value
    .filter((val) => props.model.modelProcessId === val.processId)
    .map((val) => ({title: val.name, data: val}))
);

function onTrash() {
  const data = {
    modalName: Modals.ModelTrash,
    isShowCancel: false,
    title: "확인",
    content: "파일을 삭제하시겠습니까?",
    result: {modelId: props.model.id},
  };
  CommonStore().showGlobalModal(data);
}
function onChangePainting() {
  modelStore.setModelPaint(props.model.id, isPaint.value);
}
function onModelCount() {
  if (!modelCount.value) modelCount.value = 1;
  if (modelCount.value > 30) modelCount.value = 30;
  modelStore.setModelCount(props.model.id, modelCount.value);
}
function onBlurModelCount() {
  if (!modelCount.value) modelCount.value = 1;
  if (modelCount.value > 30) modelCount.value = 30;
  modelStore.setModelCount(props.model.id, modelCount.value);
}
async function onDropProcess(item) {
  modelStore.setModelProcess(props.model.id, item.data.id);
  dropProcessTitle.value = item.data.name;
  for (let m = 0; m < materials.value.length; m++) {
    const mate = materials.value[m];
    if (props.model.modelProcessId === mate.processId) {
      dropMaterialTitle.value = mate.name;
      modelStore.setModelMaterial(props.model.id, mate.id);
      await modelStore.reqActiveModel(props.model);
      await modelStore.reqGetAnalysis(props.model.id, item.data);
      break;
    }
  }
}
function onDropMaterial(item) {
  modelStore.setModelMaterial(props.model.id, item.data.id);
  dropMaterialTitle.value = item.data.name;
  modelStore.reqActiveModel(props.model);
}
function onShowViewer() {
  modelStore.setCurrentModel(props.model);
}
</script>
